import { Role } from '../redux/reducers/role'
import { fetchRequest } from '../services/http.service'

export const GET_ROLES_URL = '/roles/client/'

export const getRolesRequest = (clientId: Number | null) =>
  fetchRequest.get<Role[]>(GET_ROLES_URL + '?clientId=' + clientId)
